import { render, staticRenderFns } from "./Dossiers.vue?vue&type=template&id=c17e2728&scoped=true"
import script from "./Dossiers.vue?vue&type=script&lang=js"
export * from "./Dossiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17e2728",
  null
  
)

export default component.exports